// extracted by mini-css-extract-plugin
export default {"noticeBox":"ModalNotice_noticeBox__9uxZ3"};